<template>
    <div class="row">
        <div class="col-12 col-sm-5 col-md-5 col-lg-5">
            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Guest: </span>
                </div>
                <div class="col-md-7">{{ guestName }}</div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Guest ID: </span>
                </div>
                <div class="col-md-7">
                    <span><strong>{{ guestId }}</strong></span>
                </div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Guest Phone No: </span>
                </div>
                <div class="col-md-7">
                    <span><strong>{{ guestMobile }}</strong></span>
                </div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Reservation No: </span>
                </div>
                <div class="col-md-7">{{ reservationNo }}</div>
            </div>

            <div class="row">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Check-in: </span>
                </div>
                <div class="col-md-7">
                    <span><strong>{{ checkinDate }}</strong></span>
                </div>
            </div>
        </div>

        <div class="col-md-2"></div>

        <div class="col-12 col-sm-5 col-md-5 col-lg-5">
            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Invoice Date: </span>
                </div>
                <div class="col-md-7">{{ formData.invoice_date }}</div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Return Date: </span>
                </div>
                <div class="col-md-7">
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="date"
                        v-model="formData.date"
                    >
                </div>
            </div>

            <div class="row h-40">
                <div class="col-md-5 d-flex align-items-center">
                    <span>Invoice No: </span>
                </div>
                <div class="col-md-7">
                    <span><strong>{{ formData.bill_number }}</strong></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
    guest: {
        type: Object,
        default: () => ({}),
    },
})

const formData = inject('formData');

const guestName = computed(() => {
    if (! props.guest.patient) return '';
    return props.guest.patient.full_name;
})

const guestId = computed(() => {
    if (! props.guest.patient) return '';
    return props.guest.patient.serial_no;
})

const guestMobile = computed(() => {
    if (! props.guest.patient) return '';
    return props.guest.patient.mobile_no;
})

const reservationNo = computed(() => {
    if (! props.guest.admission_no) return '';
    return props.guest.admission_no;
})

const checkinDate = computed(() => {
    if (! props.guest.admission_date) return '';
    return props.guest.admission_date;
})
</script>

<style scoped>
.h-40 {
    height: 40px;
    align-items: center;
}
</style>
